import { render, staticRenderFns } from "./ExternalBans.vue?vue&type=template&id=5520308d"
import script from "./ExternalBans.vue?vue&type=script&lang=js"
export * from "./ExternalBans.vue?vue&type=script&lang=js"
import style0 from "./ExternalBans.vue?vue&type=style&index=0&id=5520308d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports